import { TableCell, Typography } from "@mui/material";

interface QuarterSummaryCellProps {
  value?: string | number;
  bgColor?: string;
  fontWeight?: any;
  isSticky?: boolean;
  leftOffset?: number;
  rightOffset?: number;
  hasBorder?: boolean;
}

const QuarterSummaryCell: React.FC<QuarterSummaryCellProps> = ({
  value,
  bgColor = "#F5F5F5",
  fontWeight = "medium",
  isSticky = false,
  leftOffset,
  rightOffset,
  hasBorder = false,
}) => {
  return (
    <TableCell
      align="center"
      sx={{
        backgroundColor: bgColor,
        padding: "0px 8px !important",
        ...(isSticky &&
          leftOffset !== undefined && {
            position: "sticky",
            left: leftOffset,
            zIndex: 2,
          }),
        ...(isSticky &&
          rightOffset !== undefined && {
            position: "sticky",
            right: rightOffset,
            zIndex: 2,
          }),
        ...(hasBorder && { borderRight: "1px solid #e0e0e0" }),
      }}
    >
      {value && (
        <Typography variant="body2" sx={{ fontWeight }}>
          {value}
        </Typography>
      )}
    </TableCell>
  );
};

export default QuarterSummaryCell;
